export default __webpack_public_path__ + "static/media/12-28.ef88fb96.png";